import React, { useContext } from 'react';
import { Animate, Card } from 'pcln-design-system';
import { productsType } from '../../constants';
import styled from 'styled-components';
import { TripCard } from './TripCard';
import { getPackageTrips } from './getPackageTrips';
import { myTripContextData } from './myTripDataContext';
import { formatTripMessageContent } from './formatTripMessageContent';
const StyledTripsLinkCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "MyTripsList__StyledTripsLinkCard",
  componentId: "sc-zjs0pq-0"
})(["cursor:pointer;"]);
// DATE logic must happen on the client so we can know the current locale date (vs date at server).
export const MyTripsList = props => {
  const {
    trips,
    tripCategory
  } = props;
  const {
    deepLinkPrompt,
    submitChatMessageInMarkerComponent
  } = useContext(myTripContextData);
  return React.createElement(React.Fragment, null, trips.sort((a, b) => new Date(a.travelStartDate).getTime() - new Date(b.travelStartDate).getTime()).map((trip, index) => {
    const {
      checkStatusUrl,
      type
    } = trip;
    const isPackage = type === productsType.PACKAGE;
    const actualCheckStatusUrl = `${checkStatusUrl}${deepLinkPrompt || ''}`;
    return React.createElement(Animate, {
      key: index,
      variant: 'slideInLeft',
      override: {
        transition: {
          delay: 0.1 * index || 0
        }
      }
    }, React.createElement(StyledTripsLinkCard, {
      "data-testid": `trip-link-card-${tripCategory}-${index}`,
      onClick: function (event) {
        event.preventDefault();
        if (submitChatMessageInMarkerComponent) {
          submitChatMessageInMarkerComponent({
            role: 'user',
            content: formatTripMessageContent(trip)
          }, []);
        } else {
          window.open(actualCheckStatusUrl);
        }
      },
      borderWidth: 0,
      width: 1
    }, React.createElement(TripCard, {
      trip: isPackage ? getPackageTrips(trip) : trip,
      actualCheckStatusUrl: actualCheckStatusUrl
    })));
  }));
};